/* @flow */
'use strict';

let $ = require('jquery');

function saveOriginalSelectItems($select: $): Array<HTMLElement> {
    let originalChildrenList = $.data($select, 'original-children');

    if (originalChildrenList) {
        return originalChildrenList;
    }

    // odstran 'selected' ze vsech options
    // oznacovani vybrane polozky se resi samostatne na konci funkce
    $select.find('[selected]').attr('selected', false);

    originalChildrenList = $select.children().toArray();
    $.data($select, 'original-children', originalChildrenList);

    return originalChildrenList;
}

export function setSelectItems($select: $, items: Array<string>, keepSelected: boolean = true) {
    let currentValue = $select.val();
    saveOriginalSelectItems($select);

    $select.html(items.join(''));

    if (keepSelected) {
        $select.find('[value="' + currentValue + '"]').first().attr('selected', true);
    }

    if ($select.val() !== currentValue) {
        $select.trigger('change');
    }
}

export function filterSelectItems($select: $, filter: (item: $) => bool, keepSelected: boolean = true): void {
    let currentValue = $select.val();
    let originalChildrenList = saveOriginalSelectItems($select);

    function filteredCloneSelect(originalList: Array<HTMLElement>): Array<HTMLElement> {
        let newList = [];

        originalList.forEach(function(child: HTMLElement) {
            if (child.tagName === 'OPTION') {
                if (!filter(child)) {
                    return;
                }

                child = child.cloneNode(true);

            } else if (child.tagName === 'OPTGROUP') {
                let groupChildren = filteredCloneSelect($(child).children().toArray());
                if (groupChildren.length === 0) {
                    return;
                }

                child = $(child.cloneNode(false)).append(groupChildren)[0];
            }

            newList.push(child);
        });

        return newList;
    }

    $select.empty().append(filteredCloneSelect(originalChildrenList, filter));

    if (keepSelected) {
        let $selectOption = $select.find('[value="' + currentValue + '"]');

        if ($selectOption.length === 0) {
            $selectOption = $select.children();
        }

        $selectOption.first('option').attr('selected', true);
    }

    if ($select.val() !== currentValue) {
        $select.trigger('change');
    }
}

export function groupSelectItems($select: $, groupList: Array<string>, group: (item: $) => Array<string>, keepSelected: boolean = true): void {
    const currentValue = $select.val();
    const originalChildrenList = saveOriginalSelectItems($select);

    const groups = {
        '' : $select[0],
    };

    groupList.forEach((groupName) => {
        const optgroup = document.createElement('OPTGROUP');
        optgroup.setAttribute('label', groupName);

        groups[groupName] = optgroup;
    });

    $select.empty();
    deepWalk(originalChildrenList);

    function deepWalk(items: Array<HTMLElement>): Array<HTMLElement> {
        let newList = [];

        items.forEach(function(item: HTMLElement) {
            if (item.tagName === 'OPTION') {
                group(item).forEach((groupName) => {
                    if (!groups[groupName]) {
                        return;
                    }

                    item = item.cloneNode(true);
                    groups[groupName].appendChild(item);
                });

            } else if (item.tagName === 'OPTGROUP') {
                deepWalk($(item).children().toArray());
            }
        });

        return newList;
    }

    groupList.forEach((groupName) => {
        const group = groups[groupName];

        if (!group.hasChildNodes()) {
            return;
        }

        $select.append(group);
    });

    if (keepSelected) {
        let $selectOption = $select.find('[value="' + currentValue + '"]');

        if ($selectOption.length === 0) {
            $selectOption = $select.children();
        }

        $selectOption.first('option').attr('selected', true);
    }

    if ($select.val() !== currentValue) {
        $select.trigger('change');
    }
}

export function getNumberFieldValue($field: $, allowEmpty: boolean = false): ?number {
    if ($field.length === 0) {
        return null;
    }

    let value = $field.val();

    if ($field.attr('type') !== 'number') {
        value = value.toString().replace(',', '.').replace(/\s/g, '');
    }

    if (allowEmpty && value === '') {
        return null;
    }

    value = parseFloat(value);

    if (isNaN(value)) {
        value = 0;
    }

    return value;
}

export function findField($form: $, name: string, multiField: boolean = false): $ {
    return $(':input[name$="[' + name + ']' + (multiField ? '[]' : '') + '"]', $form);
}

export function findRow($input: $): $ {
    return $input.closest('.form-group, form')
}

export function ajaxSubmit($form, $clickedButton, options = {}) {
    $form = $($form);

    // check if checkValidity method exists first
    // IE8 support

    if ($form[0].checkValidity && !$form[0].checkValidity()) {
        return Promise.reject('Form validity check failed');
    }

    let data = $form.serializeArray();

    if ($clickedButton) {
        $clickedButton = $($clickedButton);
        data.push({'name': $clickedButton.attr('name'), 'value': $clickedButton.attr('value')});
    }

    return new Promise(function(resolve, reject) {
        $.ajax({
            url: options.url || $form.attr('action') || window.location,
            type: 'post',
            dataType: 'json',
            data: data

        }).done(function (data, status, xhr) {
            if (xhr.status < 200 || xhr.status >= 400) {
                reject({ status: 'error', message: xhr.statusText });
            }

            if (data.status && (data.status == 'ok' || data.status == 'OK')) {
                resolve(data, xhr);

            } else {
                reject(data, xhr);
            }
        }).fail(function () {
            reject({ status: 'error' });
        });
    });
}


// WEBPACK FOOTER //
// ./app/Resources/assets/js/lib/form.js